import { accessKeyMessages } from 'src/features/accessKey/utils/messages';
import { ACCESS_KEY_TYPE } from 'src/features/accessKey/utils/types';
import { BadgeOption } from 'src/registry/types/badges';
import { ICON_MAP } from 'src/utils/constants';

export const accessKeyTypeBadgeOptions: Record<ACCESS_KEY_TYPE, BadgeOption> = {
    [ACCESS_KEY_TYPE.CARD]: {
        label: accessKeyMessages.card,
        icon: ICON_MAP.MEMBERSHIP_CARD,
        theme: 'green',
    },
    [ACCESS_KEY_TYPE.CHIP]: {
        label: accessKeyMessages.chip,
        icon: ICON_MAP.MEMBERSHIP_CHIP,
        theme: 'teal',
    },
    [ACCESS_KEY_TYPE.TAG]: {
        label: accessKeyMessages.tag,
        icon: ICON_MAP.MEMBERSHIP_TAG,
        theme: 'blue',
    },
    [ACCESS_KEY_TYPE.PASSWORD]: {
        label: accessKeyMessages.password,
        icon: ICON_MAP.PASSWORD,
        theme: 'orange',
    },
};

export const ACCESS_KEY_TYPE_TRANSLATION_MAP = {
    [ACCESS_KEY_TYPE.CARD]: accessKeyMessages.card,
    [ACCESS_KEY_TYPE.CHIP]: accessKeyMessages.chip,
    [ACCESS_KEY_TYPE.TAG]: accessKeyMessages.tag,
    [ACCESS_KEY_TYPE.PASSWORD]: accessKeyMessages.password,
};
